import { resolveApiBase } from "./apiBase";

export const WEBPAGE_TITLE = "Laufið";
export const API_BASE = resolveApiBase(
    process.env.LAUFID_ENDPOINT,
    "https://api2.laufid.is",
);
export const API_ENDPOINT = `${API_BASE}/`;
export const GOOGLE_GA_MEASUREMENT_ID = process.env.GA_MEASUREMENT_ID;
export const GOOGLE_GA_TRACKING_ID = process.env.GA_TRACKING_ID;
export const THEME_COLOR = "#009448";
export const LEAF_COLORS = [
    { active: "#4FC878", inactive: "#A7EEBF", background: "#EEFFF4" },
    { active: "#FD974F", inactive: "#FFCEAC", background: "#FFF1E6" },
    { active: "#4433CD", inactive: "#E3C9FC", background: "#F6EEFF" },
];
